import { render, staticRenderFns } from "./OrdersToPickWidget.vue?vue&type=template&id=53d5dd8a&"
import script from "./OrdersToPickWidget.vue?vue&type=script&lang=js&"
export * from "./OrdersToPickWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QSeparator,QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QSeparator,QTable,QTr,QTh,QTd})
